<template>
  <div class="d-flex flex-column page-title-box" v-if="listLastValue !== '' || breadcrumbList.length > 1">
    <div class="page-title-right d-block">
      <ol class="breadcrumb m-0" v-if="breadcrumbList.length > 1">
        <li
          v-for="(item, index) in breadcrumbList"
          :key="index"
          class="breadcrumb-item"
          :class="{ active: isActive(index) }"
        >
          <template v-if="isActive(index)">
            {{ item.label }}
          </template>
          <router-link v-else :to="{ name: item.name, params: item.params }">
            {{ item.label }}
          </router-link>
        </li>
      </ol>
      <h4 :class="{ 'fw-bold mb-3 mt-0': listLastValue !== '' }">
        {{ listLastValue }}
      </h4>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import _ from 'lodash'

export default {
  data() {
    return {
      breadcrumbList: []
    }
  },
  created() {
    if (this.$route.matched.length > 1) {
      this.$route.matched.forEach(route => {
        if (_.size(route.meta.breadcrumb) > 0) {
          if (route.meta.breadcrumb.parent) {
            let parentRoute = this.$router.resolve({
              name: route.meta.breadcrumb.parent
            })

            this.breadcrumbList.push({
              label: parentRoute.meta.breadcrumb.name,
              name: _.last(parentRoute.matched).name,
              params: parentRoute.params
            })
          }
        }
        if (_.isUndefined(route.name)) {
          //
        } else {
          this.breadcrumbList.push({
            label: route.meta.breadcrumb.name,
            name: route.name
          })
        }
      })
    } else {
      this.breadcrumbList.push({
        label: this.$route.meta.breadcrumb.name,
        name: this.$route.name
      })
    }
    const pageTitles = this.breadcrumbList.map(item => item.label)
    const mergedPageTitles = pageTitles.reduce((previousUrl, currentUrl) => `${currentUrl} / ${previousUrl}`)
    document.title = mergedPageTitles
  },
  watch: {
    $route: {
      // eslint-disable-next-line no-unused-vars
      handler(newValue, oldValue) {
        this.breadcrumbList = [{
          label: newValue.meta.breadcrumb.name,
          name:  newValue.name
        }]
      },
      deep: true
    }
  },
  methods: {
    isActive(index) {
      if (index === this.breadcrumbList.length - 1) {
        return true
      }

      return false
    }
  },
  computed: {
    ...mapState('breadcrumb', ['title']),
    listLastValue() {
      const title = this.title !== null ? this.title : this.breadcrumbList[this.breadcrumbList.length - 1].label

      return title !== this.$t('router.dashboard') ? title : ''
    }
  }
}
</script>
